import React from 'react';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';
import Icon from '../../../components/AppIcon';

const LoginForm = ({ 
  formData, 
  errors, 
  isLoading, 
  onInputChange, 
  onSubmit, 
  onForgotPassword,
  onGoogleAuth 
}) => {
  return (
    <form onSubmit={onSubmit} className="space-y-5">
      <Button
        type="button"
        variant="outline"
        fullWidth
        onClick={onGoogleAuth}
        disabled={isLoading}
      >
        <Icon name="Chrome" size={20} className="mr-2" />
        Sign in with Google
      </Button>
      
      <div className="relative my-6">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-border"></div>
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="px-4 bg-card text-muted-foreground">Or continue with</span>
        </div>
      </div>
      
      <Input
        label="Email Address"
        type="email"
        name="email"
        value={formData?.email}
        onChange={onInputChange}
        placeholder="partner@company.com"
        error={errors?.email}
        required
      />
      <Input
        label="Password"
        type="password"
        name="password"
        value={formData?.password}
        onChange={onInputChange}
        placeholder="Enter your password"
        error={errors?.password}
        required
      />
      <div className="flex items-center justify-between">
        <Checkbox
          label="Remember me"
          checked={formData?.rememberMe}
          onChange={onInputChange}
          name="rememberMe"
        />
        <button
          type="button"
          onClick={onForgotPassword}
          className="text-sm text-primary hover:text-primary/80 transition-colors duration-200 font-medium"
        >
          Forgot password?
        </button>
      </div>
      <Button
        type="submit"
        variant="default"
        fullWidth
        loading={isLoading}
        iconName="LogIn"
        iconPosition="left"
      >
        {isLoading ? 'Signing in...' : 'Sign In'}
      </Button>
    </form>
  );
};

export default LoginForm;